import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StructureContractService } from "../interfaces/structure-contract.service";
import { ApiService } from "../base/api-base.service";
import { NetworkStatusService } from "../network-status.service";
import { StructureOfflineService } from "../offline/structure-offline.service";
import { StructureOnlineService } from "../online/structure-online.service";
import { InspectionStructureFormat } from "../../_utils/inspection-structure.utils";

@Injectable()
export class StructureService extends ApiService<StructureContractService> implements StructureContractService {
  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: StructureOfflineService,
    protected onlineService: StructureOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
  }

  // ST01 GET /api/v1/structure
  getStructureZip(subjectModelId?: string, inspectionId?: string, withPreset?: boolean, format?: InspectionStructureFormat): Observable<Blob> {
    return this.service.getStructureZip(subjectModelId, inspectionId, withPreset, format);
  }
}
